// extracted by mini-css-extract-plugin
export default {"textInput":"Textinput_textInput__+Xtli"};